import { joinId } from "./id.js";
import { binarySearch } from "../lib/array.js";
import { defaultHandler } from "../handler/handler.js";
import "./tree.js";
//#region src/tree/node.ts
/**
* Creates a new navigation node.
*
* @see {@link NodeOptions}
* @see {@link CreatedNavigationNode}
*/
function createNode(options) {
	if (options.id.includes("/")) throw new Error("local node id cannot contain slashes");
	return {
		id: joinId(options.parent, options.id),
		connected: false,
		tree: null,
		parent: options.parent,
		order: options.order ?? null,
		handler: options.handler ?? defaultHandler,
		children: []
	};
}
/**
* Updates node properties. Only `handler` and `order` can be updated.
*
* @see {@link NodeOptions}
*/
function updateNode(node, options) {
	if (options.handler != null) node.handler = options.handler;
	if (options.order != null) updateNodeOrder(node, options.order);
}
function updateNodeOrder(node, order) {
	if (node.order === order || node.parent === null) return;
	node.order = order;
	const parentNode = node.tree?.nodes.get(node.parent);
	if (parentNode == null) return;
	const childIndex = parentNode.children.findIndex((i) => i.id === node.id);
	const newIndex = binarySearch(parentNode.children, (child) => order < (child.order ?? 0));
	if (newIndex === -1 || newIndex === childIndex) return;
	let removed = [];
	if (childIndex !== -1) {
		parentNode.children[childIndex].order = order;
		removed = parentNode.children.splice(childIndex, 1);
	}
	parentNode.children.splice(newIndex, 0, ...removed);
}
//#endregion
export { createNode, updateNode };

//# sourceMappingURL=node.js.map